export interface StreamEvent {
  type:
    | 'meta'
    | 'text_delta'
    | 'tool_call_start'
    | 'tool_running'
    | 'tool_result'
    | 'turn_end'
    | 'usage'
    | 'done'
    | 'error';
  conversationId?: string;
  text?: string;
  id?: string;
  name?: string;
  ok?: boolean;
  result?: unknown;
  iter?: number;
  stopReason?: string | null;
  inputTokens?: number;
  outputTokens?: number;
  costUsd?: number;
  message?: string;
  status?: number;
}

export async function* parseSSE(stream: ReadableStream<Uint8Array>): AsyncGenerator<StreamEvent> {
  const reader = stream.getReader();
  const decoder = new TextDecoder();
  let buf = '';
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const parts = buf.split('\n\n');
    buf = parts.pop() ?? '';
    for (const part of parts) {
      if (!part || part.startsWith(':')) continue;
      const dataLine = part.split('\n').find((l) => l.startsWith('data: '));
      if (!dataLine) continue;
      try {
        yield JSON.parse(dataLine.slice(6)) as StreamEvent;
      } catch {
        // ignore malformed
      }
    }
  }
}

export async function streamChat(
  message: string,
  conversationId: string | undefined,
  signal: AbortSignal,
): Promise<ReadableStream<Uint8Array>> {
  const res = await fetch('/api/chat/stream', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ message, conversationId }),
    signal,
    credentials: 'include',
  });
  if (!res.ok || !res.body) throw new Error(`HTTP ${res.status}`);
  return res.body;
}
